import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './change-password.component';
import {ChangePasswordService} from './change-password.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule
  ],
  declarations: [ChangePasswordComponent],
    exports: [ChangePasswordComponent],
    providers: [
      ChangePasswordService
    ]
})
export class ChangePasswordModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/change-password/change-password.module.ts